import React from 'react'
import { Form } from 'react-bootstrap'
import Portal from '@/types/Portal'
import IconWithTooltip from '@/components/shared/IconWithTooltip'
import RecordActionButtons from '@/components/RecordActionButtons'
import { RecordType } from '@/components/shared/DeleteRecordModal'
import useCopyText from '@/hooks/useCopyText'
import { useTogglePublishedMutation } from '@/features/apiSliceWithPortals'
import useToastMutation from '@/hooks/useToastMutation'

interface PortalAdminControlsProps {
  portal: Portal
  className?: string
}

export default function PortalAdminControls({
  portal,
  className,
}: PortalAdminControlsProps) {
  const publicUrl = `${window.location.origin}/${portal.slug}`
  const embedUrl = `${publicUrl}?embedded=true`
  const copyText = useCopyText()
  const [togglePublished] = useToastMutation(useTogglePublishedMutation)

  return (
    <div className={`d-flex align-items-center gap-4 ${className}`}>
      {portal.published && (
        <>
          <span
            role="button"
            style={{ cursor: 'pointer' }}
            onClick={() => {
              copyText(publicUrl, 'Public URL copied to clipboard!', 'Failed to copy URL')
            }}
          >
            <IconWithTooltip icon="fas fa-share-alt" tooltip="Copy public URL" />
          </span>
          <span
            role="button"
            style={{ cursor: 'pointer' }}
            onClick={() => {
              const iframe = `<iframe src="${embedUrl}" width="100%" height="800" style="border: none" allow="clipboard-write"></iframe>`
              copyText(iframe, 'Embed code copied to clipboard!', 'Failed to copy embed code')
            }}
          >
            <IconWithTooltip icon="fas fa-code" tooltip="Copy embed code" />
          </span>
        </>
      )}
      <Form.Check
        checked={portal.published}
        type="switch"
        id="custom-switch"
        label={portal.published ? 'Unpublish' : 'Publish'}
        onChange={({ target: { checked: published } }) => {
          togglePublished({ portalSlug: portal.slug, published })
        }}
      />
      <RecordActionButtons showDetailsButton={false} idOrSlug={portal.slug} recordType={RecordType.Portal} />
    </div>
  )
}
